import { render, staticRenderFns } from "./SamSelect.vue?vue&type=template&id=3a585a16&"
import script from "./SamSelect.vue?vue&type=script&lang=js&"
export * from "./SamSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports